import Script from 'next/script'

export const TidioChat = () => {
  return (
    <Script src="//code.tidio.co/ifjyscxfvasxhxv4obbhieuyiarauvcy.js" async strategy="lazyOnload" />
  )
}
